<template>
  <b-form-group
    :label="label"
    :label-for="inputId"
    class="form-group-modern"
  >
    <multiselect
      :id="inputId"
      v-model="selectedStore"
      :options="storeOptions"
      :searchable="true"
      :allow-empty="false"
      :show-labels="false"
      placeholder="Buscar tienda..."
      label="name"
      track-by="id"
      class="modern-multiselect"
      @input="handleStoreChange"
    >
      <template slot="noResult">
        <span>No se encontraron tiendas</span>
      </template>
      <template slot="noOptions">
        <span>Cargando tiendas...</span>
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import Multiselect from 'vue-multiselect'

export default {
  name: 'StoreSelector',
  components: {
    Multiselect
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      default: 'Tienda:'
    },
    inputId: {
      type: String,
      default: 'store-selector'
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const selectedStore = ref(null)

    const storeOptions = computed(() => {
      const storeFilters = store.getters.storeFilters
      if (!storeFilters || !Array.isArray(storeFilters)) return []

      for (const filterGroup of storeFilters) {
        if (filterGroup.levelList && Array.isArray(filterGroup.levelList)) {
          const storeLevel = filterGroup.levelList.find(level => level.id === 'store_id')
          if (storeLevel && storeLevel.options) return storeLevel.options
        }
      }

      return []
    })

    watch(() => props.value, (newValue) => {
      if (newValue && storeOptions.value.length > 0) {
        const foundStoreOption = storeOptions.value.find(option => option.id === Number(newValue))
        if (foundStoreOption) selectedStore.value = foundStoreOption
      } else {
        selectedStore.value = null
      }
    }, { immediate: true })

    watch(storeOptions, (newOptions) => {
      if (props.value && newOptions.length > 0) {
        const foundStore = newOptions.find(option => option.id === Number(props.value))
        if (foundStore) selectedStore.value = foundStore
      }
    })

    const handleStoreChange = (selected) => {
      context.emit('input', selected ? selected.id : null)
    }

    return {
      selectedStore,
      storeOptions,
      handleStoreChange
    }
  }
}
</script>

<style scoped>
.form-group-modern {
  margin-bottom: 1.5rem;
}

.modern-multiselect >>> .multiselect__tags {
  border-radius: 8px;
  border-color: #ced4da;
  min-height: 38px;
  padding: 8px 40px 0 8px;
}

.modern-multiselect >>> .multiselect__input,
.modern-multiselect >>> .multiselect__single {
  font-size: 1rem;
  line-height: 1.5;
  padding: 0;
  margin-bottom: 0;
}

.modern-multiselect >>> .multiselect__placeholder {
  color: #6c757d;
  padding-top: 0;
  margin-bottom: 0;
}

.modern-multiselect >>> .multiselect__option {
  padding: 10px 12px;
}

.modern-multiselect >>> .multiselect__option--highlight {
  background: #007bff;
  color: white;
}

.modern-multiselect >>> .multiselect__option--selected {
  background: #e9ecef;
  color: #333;
  font-weight: 500;
}

.modern-multiselect >>> .multiselect__option--selected.multiselect__option--highlight {
  background: #007bff;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/app/news_feed/components/StoreSelector.vue